module.exports = __webpack_public_path__ + "static/media/mada.59611757.svg";